import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import courseForm from "./modules/course-form";
import status from "./modules/status";
import navbar from "./modules/navbar";
import workloads from "./modules/workloads";
import workloadForm from "./modules/workload-form";
import spinner from "./modules/spinner";
import employees from "./modules/employees";
import timePeriods from "./modules/time-periods";
import translationalTeam from "./modules/translational-team";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    courseForm,
    status,
    navbar,
    workloads,
    workloadForm,
    spinner,
    employees,
    timePeriods,
    translationalTeam
  }
});
